/**
 * @prettier
 */

// React Packages
import React, { useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { withTranslation, useTranslation, Trans } from "react-i18next";

// Helpers
import { getCompanyName } from "./../../services/shared/helpers";

// Components
import Header from "../../components/Header";
import Navigator from "./../../components/Navigator";
import CustomButton from "../../components/CustomButton";

// Images
import logo from "./../../assets/img/idpal_logo.svg";

// Config
import { ACTION_LABELS } from "./../../config/dataDogActionLabels";

const LinkText = ({ linkTo = "#", title = "", ...props }) => {
    return (
        <a
            href={linkTo}
            target="_blank"
            title={title}
            aria-label={{ title }}
            rel="noreferrer"
        >
            {props.children}
        </a>
    );
};
// Constants
const ACTION = ACTION_LABELS.start;

const ReusableProfileStartPage = ({
    policies,
    submission,
    branding,
    ...props
}) => {
    const primaryFocusRef = useRef();
    const [navigation, setNavigation] = useState({
        action: "load",
        props: null,
    });
    const [showIdPoweredByIDPal, setShowIdPoweredByIDPal] = useState(false);
    const { t } = useTranslation();

    function navigateNext() {
        setNavigation({ action: "next" });
    }
    const renderPoweredByIDPal = () => (
        <div className={"identity-mark-section"}>
            <p className="identity-mark-text">{t("idpal_powered_by")}</p>
            <img className="small-logo" src={logo} alt="ID-Pal logo" />
        </div>
    );

    useEffect(() => {
        if (primaryFocusRef && primaryFocusRef.current) {
            primaryFocusRef.current.focus();
        }
        document.title = t("idpal_doc_title_start");
        if (branding?.whitelabel === 0) {
            setShowIdPoweredByIDPal(true);
        }
    }, [branding?.whitelabel, t]);

    return (
        <>
            <div className="root-layout-container reusable-profile-page">
                <Header showLanguageSelect />
                <div className="content-wrapper">
                    <h1
                        className="heading-text"
                        ref={primaryFocusRef}
                        tabIndex={0}
                    >
                        {t("idpal_reusable_start_title")}
                    </h1>
                    <h2 className="subtitle-text">
                        {t("idpal_reusable_start_subtitle", {
                            company: getCompanyName(branding.name),
                        })}
                    </h2>

                    <p className="privacy-policy-text">
                        <Trans
                            i18nKey="idpal_terms_and_conditions_warning"
                            values={{
                                sessionState: submission?.new
                                    ? t("idpal_start").toLowerCase()
                                    : t("idpal_continue").toLowerCase(),
                            }}
                            components={{
                                link1: (
                                    <LinkText
                                        linkTo={policies?.terms_and_conditions}
                                        title={"Terms and Conditions"}
                                    />
                                ),
                                link2: (
                                    <LinkText
                                        linkTo={policies?.privacy_policy}
                                        title={"here"}
                                    />
                                ),
                            }}
                        />
                    </p>
                    <div className="cta-container">
                        <CustomButton
                            id="continue"
                            label={t("idpal_start")}
                            handleClick={navigateNext}
                            actionDataLabel={ACTION.continueButton}
                        />
                    </div>
                    {showIdPoweredByIDPal && renderPoweredByIDPal()}
                </div>
            </div>
            <Navigator
                page={"re_verification_start"}
                action={navigation.action}
                propsToPass={navigation.props}
            />
        </>
    );
};
function mapStateToProps(state) {
    return {
        branding: state.config.profile.data.company_branding,
        policies: state.config.profile.data.policies,
        submission: state.submissionState.details,
    };
}

export default withTranslation("translation")(
    connect(mapStateToProps)(ReusableProfileStartPage)
);
